/**
 * IANA timezone list. Modern browsers expose `Intl.supportedValuesOf("timeZone")`
 * which returns the canonical ~400 zones; older runtimes (and SSR) fall back
 * to a hand-curated list of common zones. Either way the list is stable for
 * the life of the page so we evaluate once and freeze it.
 */
function buildTimezones(): string[] {
  type WithSupported = { supportedValuesOf?: (key: string) => string[] };
  const supported = (Intl as unknown as WithSupported).supportedValuesOf;
  if (typeof supported === "function") {
    try {
      const zones = supported("timeZone");
      if (Array.isArray(zones) && zones.length > 0) return zones;
    } catch {
      /* fall through */
    }
  }
  return FALLBACK_TIMEZONES;
}

const FALLBACK_TIMEZONES: string[] = [
  "UTC",
  "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles",
  "America/Anchorage", "America/Halifax", "America/Phoenix", "America/Toronto",
  "America/Vancouver", "America/Mexico_City", "America/Sao_Paulo", "America/Buenos_Aires",
  "America/Bogota", "America/Lima", "America/Santiago",
  "Europe/London", "Europe/Dublin", "Europe/Paris", "Europe/Berlin", "Europe/Madrid",
  "Europe/Rome", "Europe/Amsterdam", "Europe/Stockholm", "Europe/Copenhagen",
  "Europe/Warsaw", "Europe/Athens", "Europe/Istanbul", "Europe/Moscow",
  "Africa/Cairo", "Africa/Johannesburg", "Africa/Lagos", "Africa/Nairobi",
  "Asia/Dubai", "Asia/Kolkata", "Asia/Bangkok", "Asia/Singapore", "Asia/Hong_Kong",
  "Asia/Shanghai", "Asia/Tokyo", "Asia/Seoul", "Asia/Manila", "Asia/Jakarta",
  "Australia/Perth", "Australia/Adelaide", "Australia/Sydney", "Australia/Brisbane",
  "Pacific/Auckland", "Pacific/Honolulu",
];

export const TIMEZONES: string[] = buildTimezones();
